<template>
  <BaseCardSection title="Zaměření" :is-visible="isVisible" :is-optional="true" @toggle="toggleVisibility">
    <fieldset class="row g-3" id="measurementAllowedField" v-show="isVisible">
      <div class="row gy-2">
        <div class="form-group">
          <div class="form-group col-sm-12 col-md-3" aria-disabled="false">
            <label class="form-label" for="measurement-transport">Doprava zaměření (tam i zpět):</label>
            <input type="number" step="1" min="0" class="form-control" id="measurement-transport"
                   name="measurement-transport" v-model="measureInternal.distance">
          </div>
        </div>
      </div>
      <div class="row gy-2">
        <div class="form-group">
          <!-- Kontejner s automatickou šířkou a pozicováním -->
          <div class="d-inline-block position-relative">
            <!-- Tooltip umístěný v pravém horním rohu -->
            <i class="bi bi-question-circle text-muted position-absolute top-0 end-0 me-2 mt-2"
               v-tooltip="'Vyberte typ zaměření ze seznamu. Pokud Vám nevyhovuje žádná z nabízených položek (složité, specifické zaměření) nepoužívejte tuto sekci a zaměření zadejte do individuální položky.'"
               data-tooltip-position="top"></i>

            <div class="form-check my-2">
              <input class="form-check-input" type="radio" name="measurementRadio" id="small" value="small"
                     v-model="measureInternal.type">
              <label class="form-check-label" for="small">
                <span class="fw-bold">Malé</span> - jednoduché, malý rozsah
              </label>
            </div>
            <div class="form-check my-2">
              <input class="form-check-input" type="radio" name="measurementRadio" id="middle" value="middle"
                     v-model="measureInternal.type" checked>
              <label class="form-check-label" for="middle">
                <span class="fw-bold">Střední</span> - klasické realizace, střední rozsah, typicky např. kuchyně, nebo
                krb
              </label>
            </div>
            <div class="form-check my-2">
              <input class="form-check-input" type="radio" name="measurementRadio" id="big" value="large"
                     v-model="measureInternal.type">
              <label class="form-check-label" for="big">
                <span class="fw-bold">Velké</span> - složité, nepravidelné se šablonami nebo vícenásobné, např.
                kuchyně
              </label>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </BaseCardSection>
</template>

<script setup>
import {defineEmits, defineProps, ref, onMounted, watch} from "vue";
import Measure from "@/models/Measure";
import BaseCardSection from "@/components/base/BaseCardSection.vue";

const isVisible = ref(false);
const props = defineProps(['measure', 'cid']);
const emit = defineEmits(['update:measure']);
const measureInternal = ref({});
const setVisibility = (item) => {
  isVisible.value = item !== null;
};

function toggleVisibility() {
  isVisible.value = !isVisible.value;
  if (isVisible.value) {
    emit('update:measure', measureInternal.value);
  } else {
    emit('update:measure', null);
  }
}

watch(measureInternal, (newVal) => {
  if (isVisible.value) {
    emit('update:measure', newVal);
  }
}, {deep: true, immediate: true});

onMounted(() => {
  measureInternal.value = props.measure ? props.measure : new Measure({
    calculationUid: props.cid,
    distance: 0,
    type: 'middle',
  });
  setVisibility(props.measure);
})
</script>

<style scoped>
</style>